import React from "react";
import PropTypes from "prop-types";
import SizeItem from "./SizeItem";
import * as Styled from "./styles.js";

const SizeBox = ({ data, selectedItem, onBoxSelect, title }) => {
  return (
    <Styled.Container>
      <Styled.SizeHeading>{title}</Styled.SizeHeading>
      <Styled.RowDiv>
        {data.map((item) => (
          <SizeItem
            key={item.id}
            title={item.title}
            isSelected={selectedItem === item.id}
            image={item.image}
            onClick={() => onBoxSelect(item.id)}
          />
        ))}
      </Styled.RowDiv>
    </Styled.Container>
  );
};

SizeBox.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedItem: PropTypes.number.isRequired,
  onBoxSelect: PropTypes.func.isRequired,
  title: PropTypes.string,
};

SizeBox.defaultProps = {
  title: "Size",
};

export default SizeBox;
